<template>
  <AppBody title="Produtores / Gerenciar" subtitle="Lojas" :actions="actions">
    <v-form
      @submit.prevent="$loja_gerenciar.filtroLojas()"
      class="search-forms"
    >
      <v-row>
        <v-col cols="3">
          <label class="input-labels">Nome da loja</label>
          <v-text-field
            solo
            placeholder="Insira nome da loja"
            v-model="$loja_gerenciar.filter.nome"
            type="text"
            data-cy="loja"
            class="textinput"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <label class="input-labels">CPF</label>
          <v-text-field
            solo
            placeholder="Insira o nº do CPF"
            v-model="$loja_gerenciar.filter.cpf"
            type="text"
            data-cy="CPF"
            class="textinput"
            v-mask="['###.###.###-##']"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <label class="input-labels">CNPJ</label>
          <v-text-field
            solo
            placeholder="Insira o nº do CNPJ"
            v-model="$loja_gerenciar.filter.cnpj"
            type="text"
            data-cy="CNPJ"
            class="textinput"
            v-mask="['##.###.###/####-##']"
          >
          </v-text-field>
        </v-col>
        <v-col data-cy="Status" cols="3">
          <label class="input-labels">Status</label>
          <v-select
            height="48"
            :items="status"
            dense
            solo
            class="textinput"
            item-text="text"
            item-value="value"
            v-model="$loja_gerenciar.filter.status"
            placeholder="Selecione o status"
            :color="$config.dados.corinputs"
            clear-icon="mdi-close-circle-outline"
            clearable
            @click:clear-icon="clearFilterFields('status')"
            :item-color="$config.dados.corinputs"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <label class="input-labels"> Regional </label>
          <v-select
            height="48"
            :items="$loja_gerenciar.regionais"
            dense
            solo
            data-cy="Regional"
            class="textinput"
            v-model="$loja_gerenciar.filter.regional"
            placeholder="Selecione a regional"
            item-text="nome"
            item-value="idregional"
            :color="$config.dados.corinputs"
            clearable
            clear-icon="mdi-close-circle-outline"
            @click:clear-icon="clearFilterFields('regional')"
            :item-color="$config.dados.corinputs"
          >
          </v-select>
        </v-col>
        <v-col data-cy="Tipo de pessoa" cols="3">
          <label class="input-labels">Tipo de pessoa</label>
          <v-select
            height="48"
            :items="pessoa"
            dense
            solo
            class="textinput"
            v-model="$loja_gerenciar.filter.tipoPessoa"
            placeholder="Selecione o tipo de pessoa"
            :color="$config.dados.corinputs"
            clearable
            clear-icon="mdi-close-circle-outline"
            @click:clear-icon="clearFilterFields('tipoPessoa')"
            :item-color="$config.dados.corinputs"
          >
          </v-select>
        </v-col>
        <v-col data-cy="Inicial" cols="3">
          <label class="input-labels">Data da inclusão (inicial)</label>
          <v-text-field
            v-model="$loja_gerenciar.filter.dataInicio"
            type="tel"
            class="textinput"
            v-mask="['XX/XX/XXXX']"
            placeholder="dd/mm/aaaa"
            hide-details
            solo
            append-icon="mdi-calendar-blank-outline"
          ></v-text-field>
        </v-col>
        <v-col data-cy="Final" cols="3">
          <label class="input-labels">Data da inclusão (final)</label>
          <v-text-field
            v-model="$loja_gerenciar.filter.dataFim"
            type="tel"
            class="textinput"
            v-mask="['XX/XX/XXXX']"
            placeholder="dd/mm/aaaa"
            hide-details
            solo
            append-icon="mdi-calendar-blank-outline"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="2">
          <v-btn
            height="48"
            data-cy="FILTRAR"
            class="button btn-size btn-border"
            type="submit"
          >
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-data-table
      class="table-body"
      :headers="headers"
      :loading="$loja_gerenciar.cadastro.lojas_loading"
      no-data-text="Não há registro de lojas"
      loading-text="Buscando informações..."
      item-key="idloja"
      :items="orderedLojas"
      :items-per-page="10"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: 'Lojas por página',
      }"
    >
      <template v-slot:item.pessoa="{ item }">
        {{ item.tipo_pessoa === "JURIDICA" ? item.cnpj : item.cpf }}
      </template>
      <template v-slot:item.ins_dthr="{ item }">
        {{ item.ins_dthr | data_pt_br }}
      </template>
      <template v-slot:item.ativo="{ item }">
        {{ item.ativo ? "ATIVO" : "INATIVO" }}
      </template>
      <template v-slot:item.actions="{ item }" class="table-actions">
        <div style="display: flex; justify-content: center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                width="30"
                small
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="goToLojas('editar', item.idloja, item.sequenciador)"
                class="lojas-gerenciar-button01"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 'PUBLICADO'"
                :color="$config.dados.corinputs"
                height="30"
                width="30"
                x-small
                dark
                v-bind="attrs"
                v-on="on"
                class="lojas-gerenciar-button01"
              >
                <AccessIcon />
              </v-btn>
            </template>
            <span>Acessar</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                width="30"
                x-small
                dark
                v-bind="attrs"
                v-on="on"
                class="lojas-gerenciar-button01"
              >
                <ProductIcon />
              </v-btn>
            </template>
            <span>Produtos</span>
          </v-tooltip> -->
          <v-tooltip bottom v-if="item.status == 'ATIVO'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                v-bind="attrs"
                v-on="on"
                width="30"
                small
                dark
                icon
                @click="
                  $loja_gerenciar.alterarStatusLojas(item.idloja, 'INATIVO')
                "
              >
                <v-icon>mdi-account-cancel-outline</v-icon>
              </v-btn>
            </template>
            <span>Inativar Loja</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                v-bind="attrs"
                v-on="on"
                width="30"
                small
                icon
                dark
                @click="
                  $loja_gerenciar.alterarStatusLojas(item.idloja, 'ATIVO')
                "
              >
                <!-- <ActiveIcon /> -->
                <v-icon>mdi-account-check-outline</v-icon>
              </v-btn>
            </template>
            <span>Ativar</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </AppBody>
</template>

<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import _ from "lodash";
export default {
  name: "Producers",
  metaInfo: {
    title: "Produtores - ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Produtores - ElevenTickets",
      },
    ],
  },
  mixins: [LojasGerenciarMixins],
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    AccessIcon: () => import("@/components/icons/AccessIcon.vue"),
    // ActiveIcon: () => import("@/components/icons/ActiveIcon.vue"),
    // InactiveIcon: () => import("@/components/icons/InactiveIcon.vue"),
    // ProductIcon: () => import("@/components/icons/ProductIcon.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Novo produtor",
          action: () => this.goToLojas("new", ""),
        },
      ],

      // HEADER //
      headers: [
        {
          text: "Sequenciador",
          align: "center",
          sortable: true,
          value: "sequenciador",
          width: "90px",
        },
        {
          text: "Nome da Loja",
          align: "center",
          sortable: true,
          value: "nome_loja",
          width: "150px",
        },
        {
          text: "CPF/CNPJ",
          align: "center",
          sortable: false,
          value: "pessoa",
          width: "150px",
        },
        {
          text: "Tipo de Pessoa",
          align: "center",
          sortable: true,
          value: "tipo_pessoa",
          width: "100px",
        },
        {
          text: "Data de Cadastro",
          align: "center",
          sortable: true,
          value: "ins_dthr",
          width: "90px",
        },
        {
          text: "Regional",
          align: "center",
          sortable: true,
          value: "regional_nome",
          width: "130px",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
          width: "90px",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          fixed: false,
          value: "actions",
          width: "130px",
        },
      ],
    };
  },
  computed: {
    orderedLojas() {
      return _.orderBy(this.$loja_gerenciar.lojas, ["ins_dthr"], ["desc"]);
    },
  },
  methods: {
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$loja_gerenciar.filter.status = "";
          break;
        case "regional":
          this.$loja_gerenciar.filter.regional = "";
          break;
        case "tipo_pessoa":
          this.$loja_gerenciar.filter.tipoPessoa = "";
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.$loja_gerenciar.getAllLojas();

    if (!this.$axios.getLocal("regionais")) {
      this.$loja_gerenciar.getRegionais();
    }
    this.$loja_gerenciar.regionais = this.$axios.getLocal("regionais").data;
  },
  destroyed() {
    this.$loja_gerenciar.limpaFiltros();
  },
};
</script>

<style scoped>
.lojas-gerenciar-button01 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: transparent;
}

.lojas-gerenciar-icon {
  fill: var(--dl-color-gray-white);
  width: 20px;
  height: 20px;
}
</style>
